<div class="date-input">
  {#if icon}
    <i bind:this={trigger} class="pointer material-icon" tabindex="-1">event</i>
  {:else}
    <i bind:this={trigger} class="fas fa-calendar pointer" tabindex="-1"></i>
  {/if
  }
  <input placeholder="DD/MM/YYYY" class="{className}" type="text" bind:value={dateVal} bind:this={dateElement}>
</div>

<script>
  import { onMount, createEventDispatcher } from 'svelte'
  import { format, parse, parseISO } from 'date-fns'

  export let date = new Date()
  export let className = ''
  export let futureYears = false
  export let icon

  const dispatch = createEventDispatcher()

  $: dateVal = date

  let dateElement
  let trigger

  $: {
    if (typeof date === 'object') {
      date = format(date, 'dd/MM/yyyy')
    } else if (date && typeof date === 'string' && !/^\d{2}\/\d{2}\/\d{4}$/.test(date) && date.length > 10) {
      date = format(parseISO(date), 'dd/MM/yyyy')
    }
  }

  onMount(async () => {
    const Pikaday = (await import('pikaday')).default
    const curYear = new Date().getFullYear()
    const yearRange = futureYears ? [1910, curYear + 100] : [1910, curYear]

    let opts = {
      field: dateElement,
      trigger,
      yearRange,
      format: 'DD/MM/YYYY',
      setDefaultDate: true,
      keyboardInput: false,
      toString (date) {
        return format(date, 'dd/MM/yyyy')
      },
      parse (dateString) {
        return parse(dateString, 'dd/MM/yyyy', new Date())
      },
      onSelect (selectedDate) {
        date = format(selectedDate, 'dd/MM/yyyy')
        dispatch('dateSelected', selectedDate)
      },
    }

    const p = new Pikaday(opts)
    opts = p.config(opts)

    dateElement.removeEventListener('change', p._onInputChange)
    p._onInputChangeOriginal = p._onInputChange
    p._onInputChange = function (e) {
      const bound = p._o.bound
      p._o.bound = false

      p._onInputChangeOriginal(e)

      p._o.bound = bound

      setTimeout(() => {
        p.hide()
      }, 0)
    }
    dateElement.addEventListener('change', p._onInputChange)
  })
</script>

<style>
  .date-input {
    position: relative;
  }

  i {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.3em;
    font-style: normal;
  }

  .pointer {
    cursor: pointer;
  }

</style>

<svelte:head>
  <link rel="stylesheet" type="text/css" href="https://cdn.jsdelivr.net/npm/pikaday/css/pikaday.css">
</svelte:head>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>